<template>
  <ValidationProvider :mode="mode"
                      :name="$attrs.label"
                      :rules="rules"
                      v-slot="{ errors, valid }">
    <v-select v-model="innerValue"
              :error-messages="errors"
              v-bind="$attrs"
              v-on="$listeners" />
  </ValidationProvider>
</template>

<script>
import { ValidationProvider } from 'vee-validate';

export default {
  components: {
    ValidationProvider
  },
  props: {
    rules: {
      type: [Object, String],
      default: ''
    },
    value: {
      type: null,
      default: ''
    },
    mode: {
      type: String,
      default: 'aggressive'
    },
  },
  data: () => ({
    innerValue: ''
  }),
  watch: {
    // Handles internal model changes.
    innerValue(newVal) {
      this.$emit('input', newVal);
    },
    // Handles external model changes.
    value(newVal) {
      this.innerValue = newVal;
    }
  },
  created() {
    if (this.value) {
      this.innerValue = this.value;
    }
  }
};
</script>
